import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { forkJoin } from "rxjs";
import { LoopBackConfig } from "../../../shared/sdk";
import { NgxImageCompressService } from "ngx-image-compress";

@Injectable({
  providedIn: "root",
})
export class HelperService {
  constructor(
    private http: HttpClient,
    private snackbar: MatSnackBar,
    private imageCompress: NgxImageCompressService) { }

  /**
   *
   * @param files files to be uploaded on s3bucketUrl
   */
  uploadFile(files: any[], uploadPath: string, adminId: string): Promise<any> {
    let requests = [];
    for (let el of files) {
      const formData = new FormData();
      formData.append("file", el.file);

      const headers = new HttpHeaders();
      headers.append("Content-type", "multipart/form-data");
      headers.append("Accept", "application/json");

      const params = {
        access_token: adminId,
      };

      const url: string =
        LoopBackConfig.getPath() +
        "/" +
        LoopBackConfig.getApiVersion() +
        "/containers/" +
        encodeURIComponent(uploadPath) +
        "/upload";

      requests.push(
        this.http.post(url, formData, { headers: headers, params: params })
      );
    }
    return new Promise((resolve, reject) => {
      forkJoin(requests).subscribe(
        (results: any[]) => {
          results = results.map((el, index) => ({
            src: results[index],
            type: files[index].type,
          }));
          resolve(results);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getValue(key: string, value: string, type: string) {
    let message = "";
    if (key === "automaticMessage") {
      message =
        type === "encrypt"
          ? value.replace("USER NAME", "#").replace("PRIZE NAME", "^")
          : value.replace("#", "USER NAME").replace("^", "PRIZE NAME");
    } else if (key === "automaticDonationMessage") {
      message =
        type === "encrypt"
          ? value.replace("USER NAME", "#").replace("ORGANIZATION NAME", "*")
          : value.replace("#", "USER NAME").replace("*", "ORGANIZATION NAME");
    } else if (key === 'socialLoginPrompt') {
      message =
        type === "encrypt"
          ? value.replace("SOCIAL LOGIN", "$")
          : value.replace("$", "SOCIAL LOGIN"); 
    }
    return message;
  }

  encryptMessage(
    key: string,
    value: string,
    name: string
  ): { value: string; name: string } {
    return {
      value: (value = this.getValue(key, value, "encrypt")),
      name: (name = this.getValue(key, name, "encrypt")),
    };
  }

  compressImage(file: File): Promise<{ compressedBase64: string, compressedBlob: Blob, originalFile: File }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = () => {
        const img = new Image();
  
        img.onload = () => {
          this.imageCompress.compressFile(reader.result.toString(), -1, 50, 50).then(
            compressedBase64 => {
              const compressedBlob = this.dataURItoBlob(compressedBase64);
              resolve({ compressedBase64, compressedBlob, originalFile: file });
            }
          );
        };
  
        img.onerror = reject;
        img.src = reader.result.toString();
      };
  
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
  
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
  
    return new Blob([ab], { type: mimeString });
  }
}
